/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountId,
  ArrayHistoricalViewRouter,
  ArrayRouterResponse,
  ArrayTenantSettingsRecord,
  AvailableObjectsResponse,
  DistroLog,
  DistroLogExplanation,
  DistroLogsFilter,
  DistroLogsPaginatedResultDistroLogSummaryDistroLogRecordsSummary,
  DistroUserAssignmentResponse,
  EligibleObjectsResponse,
  HistoricalViewRouter,
  MapSimpleObjectTypeLong,
  MapString,
  MapTypeRouterResponse,
  MigrateGraphRequest,
  MigrateGraphResponse,
  OptionRouterResponse,
  PaginatedResultDistroLogsMeta,
  PaginatedResultLogWithRouterResponse,
  PaginatedResultRouter,
  PaginatedResultRouterResponse,
  RouteDefaultMessagesResponse,
  RouterDraft,
  RouterDraftCreateRequest,
  RouterDraftUpdateRequest,
  RouterDraftValidations,
  RouterResponse,
  RoutersValidations,
  RoutingRetryRequest,
  RoutingRetryResponse,
  RulesMigrationResponse,
  Settings,
  TenantSettings,
  TenantSettingsRecord,
  TriggerEventTypeFilter,
  UpdateActionsMigrationResponse,
  UpdateEligibleObjectsRequest,
  UpdateEligibleObjectsResponse,
  UsageBulkRequestRes,
  UsageRequestRes,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "distro";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description creates a router draft
   *
   * @tags CRUD/Draft, v1
   * @name CreateARouterDraft
   * @request POST:/v1/tenant/{tenantId}/router/draft
   * @secure
   */
  createARouterDraft = (tenantId: string, data: RouterDraftCreateRequest, params: RequestParams = {}) =>
    this.request<
      RouterDraft,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/draft`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createARouterDraft */
  createARouterDraftPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/router/draft`);

  /**
   * @description retrieve a router or its draft depending on which on has the latest changes
   *
   * @tags CRUD/Draft, v1
   * @name RetrieveARouterOrItsDraft
   * @request GET:/v1/tenant/{tenantId}/router/{routerId}
   * @secure
   */
  retrieveARouterOrItsDraft = (
    tenantId: string,
    routerId: string,
    query?: {
      /** @format int32 */
      revision?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveARouterOrItsDraft */
  retrieveARouterOrItsDraftPathGetter = (
    tenantId: string,
    routerId: string,
    query?: {
      /** @format int32 */
      revision?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}`, query);

  /**
   * @description update a router draft
   *
   * @tags CRUD/Draft, v1
   * @name UpdateARouterDraft
   * @request PUT:/v1/tenant/{tenantId}/router/{routerId}
   * @secure
   */
  updateARouterDraft = (
    tenantId: string,
    routerId: string,
    data: RouterDraftUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      RouterDraft,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateARouterDraft */
  updateARouterDraftPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}`);

  /**
   * @description delete a router and its draft
   *
   * @tags CRUD/Draft, v1
   * @name DeleteARouterAndItsDraft
   * @request DELETE:/v1/tenant/{tenantId}/router/{routerId}
   * @secure
   */
  deleteARouterAndItsDraft = (
    tenantId: string,
    routerId: string,
    query?: {
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteARouterAndItsDraft */
  deleteARouterAndItsDraftPathGetter = (
    tenantId: string,
    routerId: string,
    query?: {
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}`, query);

  /**
   * @description retrieve routers or drafts depending on which on has the latest changes
   *
   * @tags CRUD/Draft, v1
   * @name RetrieveRoutersByIds
   * @request GET:/v1/tenant/{tenantId}/router-by-ids
   * @secure
   */
  retrieveRoutersByIds = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ids: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapTypeRouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveRoutersByIds */
  retrieveRoutersByIdsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ids: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/router-by-ids`, query);

  /**
   * @description retrieve paginated list of routers or drafts for a specific workspace and/or AR
   *
   * @tags CRUD/Draft, v1
   * @name GetFilteredRouters
   * @request GET:/v1/tenant/{tenantId}/routers
   * @secure
   */
  getFilteredRouters = (
    tenantId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "3e64b9fe-137f-401b-9506-764998ba5157"
       */
      workspace?: string;
      /** @example "router name" */
      name?: string;
      /** @example true */
      isActive?: boolean;
      /** @example "Lead" */
      triggerObjectType?: string;
      /** @example ["Signal","NewRecord"] */
      triggerEventTypes?: TriggerEventTypeFilter[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultRouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/routers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getFilteredRouters */
  getFilteredRoutersPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "3e64b9fe-137f-401b-9506-764998ba5157"
       */
      workspace?: string;
      /** @example "router name" */
      name?: string;
      /** @example true */
      isActive?: boolean;
      /** @example "Lead" */
      triggerObjectType?: string;
      /** @example ["Signal","NewRecord"] */
      triggerEventTypes?: TriggerEventTypeFilter[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/routers`, query);

  /**
   * @description retrieve published routers for a given workspace id
   *
   * @tags CRUD/Draft, v1
   * @name RetrievePublishedRoutersForASpecificWorkspace
   * @request GET:/v1/tenant/{tenantId}/routers/published
   * @secure
   */
  retrievePublishedRoutersForASpecificWorkspace = (
    tenantId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "3e64b9fe-137f-401b-9506-764998ba5157"
       */
      workspace?: string;
      /** @example "router name" */
      name?: string;
      /** @example true */
      isActive?: boolean;
      /** @example "Lead" */
      triggerObjectType?: string;
      /** @example ["Signal","NewRecord"] */
      triggerEventTypes?: TriggerEventTypeFilter[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultRouter,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/routers/published`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrievePublishedRoutersForASpecificWorkspace */
  retrievePublishedRoutersForASpecificWorkspacePathGetter = (
    tenantId: string,
    query?: {
      /**
       * @pattern [^\s\\/]+
       * @example "3e64b9fe-137f-401b-9506-764998ba5157"
       */
      workspace?: string;
      /** @example "router name" */
      name?: string;
      /** @example true */
      isActive?: boolean;
      /** @example "Lead" */
      triggerObjectType?: string;
      /** @example ["Signal","NewRecord"] */
      triggerEventTypes?: TriggerEventTypeFilter[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/routers/published`, query);

  /**
   * @description retrieve router history for a given router
   *
   * @tags CRUD/Draft, v1
   * @name RetrieveRouterHistoryForAGivenRouter
   * @request GET:/v1/tenant/{tenantId}/router/{routerId}/history
   * @secure
   */
  retrieveRouterHistoryForAGivenRouter = (
    tenantId: string,
    routerId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * @format int32
       * @exclusiveMin 0
       */
      fromVersion?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultRouter,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveRouterHistoryForAGivenRouter */
  retrieveRouterHistoryForAGivenRouterPathGetter = (
    tenantId: string,
    routerId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * @format int32
       * @exclusiveMin 0
       */
      fromVersion?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/history`, query);

  /**
   * @description discard a router draft, the published version is return if it exists
   *
   * @tags CRUD/Draft, v1
   * @name DiscardARouterDraft
   * @request DELETE:/v1/tenant/{tenantId}/router/{routerId}/draft
   * @secure
   */
  discardARouterDraft = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      OptionRouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/draft`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for discardARouterDraft */
  discardARouterDraftPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/draft`);

  /**
   * @description publish a draft router, it can be also edited or activate in this same call
   *
   * @tags CRUD/Draft, v1
   * @name PublishADraftRouter
   * @request PUT:/v1/tenant/{tenantId}/router/{routerId}/publish
   * @secure
   */
  publishADraftRouter = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      RouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/publish`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publishADraftRouter */
  publishADraftRouterPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/publish`);

  /**
   * @description activate a published and inactive router
   *
   * @tags CRUD/Draft, v1
   * @name ActivateAPublished
   * @request PUT:/v1/tenant/{tenantId}/router/{routerId}/activate
   * @secure
   */
  activateAPublished = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      RouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/activate`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for activateAPublished */
  activateAPublishedPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/activate`);

  /**
   * @description deactivate a published and inactive router
   *
   * @tags CRUD/Draft, v1
   * @name DeactivateAPublished
   * @request PUT:/v1/tenant/{tenantId}/router/{routerId}/deactivate
   * @secure
   */
  deactivateAPublished = (
    tenantId: string,
    routerId: string,
    query?: {
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/deactivate`,
      method: "PUT",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deactivateAPublished */
  deactivateAPublishedPathGetter = (
    tenantId: string,
    routerId: string,
    query?: {
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/deactivate`, query);

  /**
   * @description duplicate a router published definition or its latest draft when not published
   *
   * @tags CRUD/Draft, v1
   * @name DuplicateARouter
   * @request POST:/v1/tenant/{tenantId}/router/{routerId}/duplicate
   * @secure
   */
  duplicateARouter = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      RouterDraft,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/duplicate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for duplicateARouter */
  duplicateARouterPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/duplicate`);

  /**
   * @description retrieve latest version of routers available at selected timeframe
   *
   * @tags CRUD/Draft, v1
   * @name RetrieveRoutersAvailableAtTimeframe
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/routers-latest-historical
   * @secure
   */
  retrieveRoutersAvailableAtTimeframe = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayHistoricalViewRouter,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/routers-latest-historical`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveRoutersAvailableAtTimeframe */
  retrieveRoutersAvailableAtTimeframePathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/routers-latest-historical`, query);

  /**
   * @description retrieve latest version of router available at selected timeframe
   *
   * @tags CRUD/Draft, v1
   * @name RetrieveRouterAvailableAtTimeframe
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/routers-latest-historical/{routerId}
   * @secure
   */
  retrieveRouterAvailableAtTimeframe = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      HistoricalViewRouter,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/routers-latest-historical/${routerId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveRouterAvailableAtTimeframe */
  retrieveRouterAvailableAtTimeframePathGetter = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    query: {
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2024-03-18T16:29:07Z"
       */
      until?: string;
    },
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/routers-latest-historical/${routerId}`, query);

  /**
   * @description validate current draft router
   *
   * @tags CRUD/Draft, v1
   * @name ValidateDraftOfRouter
   * @request GET:/v1/tenant/{tenantId}/router/{routerId}/draft/validate
   * @secure
   */
  validateDraftOfRouter = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      RouterDraftValidations,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/draft/validate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for validateDraftOfRouter */
  validateDraftOfRouterPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/draft/validate`);

  /**
   * @description validate current draft router
   *
   * @tags CRUD/Draft, v1
   * @name ValidateDraftOfRouter2
   * @request GET:/v1/tenant/{tenantId}/router/{routerId}/validate
   * @originalName validateDraftOfRouter
   * @duplicate
   * @secure
   */
  validateDraftOfRouter2 = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      RoutersValidations,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/validate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for validateDraftOfRouter2 */
  validateDraftOfRouter2PathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/validate`);

  /**
   * @description get default notification messages for a specific route in a router
   *
   * @tags CRUD/Draft, v1
   * @name GetNotificationDefaultMessages
   * @request GET:/v1/tenant/{tenantId}/router/{routerId}/route/{routeId}/default-messages
   * @secure
   */
  getNotificationDefaultMessages = (tenantId: string, routerId: string, routeId: string, params: RequestParams = {}) =>
    this.request<
      RouteDefaultMessagesResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/route/${routeId}/default-messages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getNotificationDefaultMessages */
  getNotificationDefaultMessagesPathGetter = (tenantId: string, routerId: string, routeId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/route/${routeId}/default-messages`);

  /**
   * @description add scheduler trigger to a router draft
   *
   * @tags CRUD/Draft, v1
   * @name AddSchedulerTrigger
   * @request PUT:/v1/tenant/{tenantId}/router/{routerId}/draft/addSchedulerTrigger
   * @secure
   */
  addSchedulerTrigger = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      RouterDraft,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/draft/addSchedulerTrigger`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for addSchedulerTrigger */
  addSchedulerTriggerPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/draft/addSchedulerTrigger`);

  /**
   * @description retrieve Distro log
   *
   * @tags Distro Logs, v1
   * @name RetrieveDistroLog
   * @request GET:/v1/tenant/{tenantId}/logs/{routerId}/{logId}
   * @secure
   */
  retrieveDistroLog = (tenantId: string, routerId: string, logId: string, params: RequestParams = {}) =>
    this.request<
      DistroLog,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/logs/${routerId}/${logId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveDistroLog */
  retrieveDistroLogPathGetter = (tenantId: string, routerId: string, logId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/logs/${routerId}/${logId}`);

  /**
   * @description Explains Distro log using AI
   *
   * @tags Distro Logs, v1
   * @name ExplainDistroLog
   * @request GET:/v1/tenant/{tenantId}/logs/{routerId}/explain/{logId}
   * @secure
   */
  explainDistroLog = (tenantId: string, routerId: string, logId: string, params: RequestParams = {}) =>
    this.request<
      DistroLogExplanation,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/logs/${routerId}/explain/${logId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for explainDistroLog */
  explainDistroLogPathGetter = (tenantId: string, routerId: string, logId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/logs/${routerId}/explain/${logId}`);

  /**
   * @description Retrieve logs for a given router
   *
   * @tags Distro Logs, v1
   * @name RetrieveLogsForAGivenRouter
   * @request POST:/v1/tenant/{tenantId}/logs/{routerId}
   * @secure
   */
  retrieveLogsForAGivenRouter = (
    tenantId: string,
    routerId: string,
    data: DistroLogsFilter,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      DistroLogsPaginatedResultDistroLogSummaryDistroLogRecordsSummary,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/logs/${routerId}`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveLogsForAGivenRouter */
  retrieveLogsForAGivenRouterPathGetter = (
    tenantId: string,
    routerId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/logs/${routerId}`, query);

  /**
   * @description Retrieve routers' logs summary for a given workspace id
   *
   * @tags Distro Logs, v1
   * @name RetrieveRoutersLogsSummaryForAnSpecificWorkspace
   * @request GET:/v1/tenant/{tenantId}/logs
   * @secure
   */
  retrieveRoutersLogsSummaryForAnSpecificWorkspace = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspace: string;
      from?: string;
      filter?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultDistroLogsMeta,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveRoutersLogsSummaryForAnSpecificWorkspace */
  retrieveRoutersLogsSummaryForAnSpecificWorkspacePathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspace: string;
      from?: string;
      filter?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/logs`, query);

  /**
   * @description Retrieve paginated logs and their routers for an specific workspace and a given filter
   *
   * @tags Distro Logs, v1
   * @name RetrievePaginatedLogAndItsRouterForFilter
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/logs
   * @secure
   */
  retrievePaginatedLogAndItsRouterForFilter = (
    tenantId: string,
    workspaceId: string,
    data: DistroLogsFilter,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultLogWithRouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/logs`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrievePaginatedLogAndItsRouterForFilter */
  retrievePaginatedLogAndItsRouterForFilterPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/logs`, query);

  /**
   * @description retrieve distro user assignments
   *
   * @tags Distro user assignments, v1
   * @name RetrieveDistroUserAssignments
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/router/{routerId}/logs/user-assignments
   * @secure
   */
  retrieveDistroUserAssignments = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      DistroUserAssignmentResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}/logs/user-assignments`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveDistroUserAssignments */
  retrieveDistroUserAssignmentsPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}/logs/user-assignments`);

  /**
   * @description republish all routers
   *
   * @tags Management, v1
   * @name RepublishAllRouters
   * @request PUT:/v1/tenant/{tenantId}/republish-all-routers
   * @secure
   */
  republishAllRouters = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ArrayRouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/republish-all-routers`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for republishAllRouters */
  republishAllRoutersPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/republish-all-routers`);

  /**
   * @description deactivate all routers, if force enabled cleans up all tenant's resources in the Distro salesforce (streaming) service
   *
   * @tags Management, v1
   * @name DeactivateAllRouters
   * @request PUT:/v1/tenant/{tenantId}/deactivate-all-routers
   * @secure
   */
  deactivateAllRouters = (
    tenantId: string,
    query?: {
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayRouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/deactivate-all-routers`,
      method: "PUT",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deactivateAllRouters */
  deactivateAllRoutersPathGetter = (
    tenantId: string,
    query?: {
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/deactivate-all-routers`, query);

  /**
   * @description revert router to the last active revision
   *
   * @tags Management, v1
   * @name RevertRouter
   * @request PUT:/v1/tenant/{tenantId}/router/{routerId}/revert
   * @secure
   */
  revertRouter = (tenantId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      RouterResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/revert`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for revertRouter */
  revertRouterPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/revert`);

  /**
   * @description migrate implicit rules used by Distro routers to explicit for a given workspace
   *
   * @tags Management, v1
   * @name MigrateRulesToExplicit
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/migrate-rules-to-explicit
   * @secure
   */
  migrateRulesToExplicit = (
    tenantId: string,
    workspaceId: string,
    query?: {
      dry?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RulesMigrationResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/migrate-rules-to-explicit`,
      method: "PUT",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for migrateRulesToExplicit */
  migrateRulesToExplicitPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      dry?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/migrate-rules-to-explicit`, query);

  /**
   * @description migrate update actions from implicit relations to explicit for a given workspace
   *
   * @tags Management, v1
   * @name MigrateUpdateActionToExplicitRelations
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/migrate-update-actions-to-explicit
   * @secure
   */
  migrateUpdateActionToExplicitRelations = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      routerId?: string;
      dry?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UpdateActionsMigrationResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/migrate-update-actions-to-explicit`,
      method: "PUT",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for migrateUpdateActionToExplicitRelations */
  migrateUpdateActionToExplicitRelationsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      routerId?: string;
      dry?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/migrate-update-actions-to-explicit`, query);

  /**
   * @description returns history of global tenant settings
   *
   * @tags Management, v1
   * @name GetTenantSettings
   * @request GET:/v1/tenant/{tenantId}/settings
   * @secure
   */
  getTenantSettings = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ArrayTenantSettingsRecord,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTenantSettings */
  getTenantSettingsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * @description updates push topic tenant settings
   *
   * @tags Management, v1
   * @name UpdatePushTopicTenantSettings
   * @request PUT:/v1/tenant/{tenantId}/settings/push-topic-settings
   * @secure
   */
  updatePushTopicTenantSettings = (tenantId: string, data: TenantSettings, params: RequestParams = {}) =>
    this.request<
      TenantSettingsRecord,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings/push-topic-settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updatePushTopicTenantSettings */
  updatePushTopicTenantSettingsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/settings/push-topic-settings`);

  /**
   * @description Gets all settings
   *
   * @tags v1, Settings
   * @name GetSettings
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings
   * @secure
   */
  getSettings = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Settings,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSettings */
  getSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`);

  /**
   * @description Gets a list of available objects for selection
   *
   * @tags v1, Settings
   * @name GetAvailableObjects
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings/available-objects
   * @secure
   */
  getAvailableObjects = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      AvailableObjectsResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/available-objects`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailableObjects */
  getAvailableObjectsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/available-objects`);

  /**
   * @description Gets a list of eligible objects used in Routers
   *
   * @tags v1, Settings
   * @name GetEligibleObjects
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings/eligible-objects
   * @secure
   */
  getEligibleObjects = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      EligibleObjectsResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/eligible-objects`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getEligibleObjects */
  getEligibleObjectsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/eligible-objects`);

  /**
   * @description Sets a list of eligible objects used in Routers, deactivates affected routers
   *
   * @tags v1, Settings
   * @name SetEligibleObjects
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings/eligible-objects
   * @secure
   */
  setEligibleObjects = (
    tenantId: string,
    workspaceId: string,
    query: {
      dry: boolean;
    },
    data: UpdateEligibleObjectsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      UpdateEligibleObjectsResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/eligible-objects`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for setEligibleObjects */
  setEligibleObjectsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      dry: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/eligible-objects`, query);

  /**
   * @description Gets count of active routers per object type
   *
   * @tags v1, Settings
   * @name GetObjectUsage
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings/object-usage
   * @secure
   */
  getObjectUsage = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      MapSimpleObjectTypeLong,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/object-usage`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getObjectUsage */
  getObjectUsagePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings/object-usage`);

  /**
   * @description Retry a failed routing
   *
   * @tags Routing, v1
   * @name RetryAFailedRouting
   * @request POST:/v1/tenant/{tenantId}/router/{routerId}/routing/retry
   * @secure
   */
  retryAFailedRouting = (tenantId: string, routerId: string, data: RoutingRetryRequest, params: RequestParams = {}) =>
    this.request<
      RoutingRetryResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/routing/retry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retryAFailedRouting */
  retryAFailedRoutingPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/routing/retry`);

  /**
   * @description Bulk retry a failed routing
   *
   * @tags Routing, v1
   * @name BulkRetryAFailedRouting
   * @request POST:/v1/tenant/{tenantId}/router/{routerId}/routing/bulk-retry
   * @secure
   */
  bulkRetryAFailedRouting = (
    tenantId: string,
    routerId: string,
    data?: RoutingRetryRequest[],
    params: RequestParams = {},
  ) =>
    this.request<
      RoutingRetryResponse[],
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/router/${routerId}/routing/bulk-retry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkRetryAFailedRouting */
  bulkRetryAFailedRoutingPathGetter = (tenantId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/router/${routerId}/routing/bulk-retry`);

  /**
   * @description attempts migrated LeanData graph to Distro
   *
   * @tags LeanData/Migration
   * @name MigrateLeanDataGraphEndpoint
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/leandata/migrate/graph
   * @secure
   */
  migrateLeanDataGraphEndpoint = (
    tenantId: string,
    workspaceId: string,
    data: MigrateGraphRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MigrateGraphResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/leandata/migrate/graph`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for migrateLeanDataGraphEndpoint */
  migrateLeanDataGraphEndpointPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/leandata/migrate/graph`);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);
}
